// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xJF6w","rootNoMargin":"styles_rootNoMargin__3TJcM"};